module.exports = __webpack_public_path__ + "media/images/pencil-box-d9af4a63f7f6cb17218c398e17c58f30.svg";